module.exports = __webpack_public_path__ + "img/edit.995ee862.svg";